





























import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import PublicLayout from '@/views/layouts/PublicLayout.vue';
@Component({
  components: { PublicLayout }
})
export default class CookiesPolicy extends Mixins<SlotMixin>(SlotMixin) {
  created () {
    this.$gtag.event('page_view', {});
  }
}
